export const CATEGORY_COLORS = ['#DBF8D1', '#E0F5FA', '#E4E0FA', '#17B26A'];

export const generateCategoryCode = (name: string): string => {
  const lettersOnly = name.toUpperCase().replace(/[^A-Z]/g, '');
  if (lettersOnly.length >= 3) {
    return lettersOnly.substring(0, 3);
  }

  const simplified = name.toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (simplified.length > 0) {
    return simplified.substring(0, 3);
  }

  return 'CAT';
};

export const getCategoryBadgeColor = (
  categoryName: string,
  categories: Array<{ name: string }>,
) => {
  const index = categories.findIndex((c) => c.name === categoryName);
  if (index === -1) {
    return { color: 'primary' as const };
  }
  return {
    color: 'custom' as const,
    customBackgroundColor: CATEGORY_COLORS[index % CATEGORY_COLORS.length],
  };
};
